import React, { useEffect, useState } from "react";
import { Input, Table } from "reactstrap";
import CustomInput from "../../../../Components/Common/CustomInput/CustomInput";

const addZeroPrefix = (number) => {
  let numString = number.toString();

  if (numString.length === 1) {
    numString = "0" + numString;
  }

  return Number(numString);
};

const TableComponent = ({
  mainHeading,
  headings,
  index,
  read,
  formik,
  report,
  onWheel,
  disableDraft,
  isVisible,
  toggleVisibility,
}) => {
  const [debitTotal, setDebitTotal] = useState([]);
  const [creditTotal, setCreditTotal] = useState([]);

  const handleTotalDebitChange = ({ index, i, subindex, value }) => {
    const temp =
      formik.values.reportTxns[index]?.reportSubTxnDtos[i]?.subTxnDtos || [];
    const total = temp.reduce((acc, num, idx) => {
      return acc + (idx === subindex ? Number(value) : Number(num?.debit || 0));
    }, 0);

    setDebitTotal((prevDebitTotal) => {
      const updatedDebitTotal = [...prevDebitTotal];
      updatedDebitTotal[i] = total;
      return updatedDebitTotal;
    });
  };

  const handleTotalCreditChange = ({ index, i, subindex, value }) => {
    const temp =
      formik.values.reportTxns[index]?.reportSubTxnDtos[i]?.subTxnDtos || [];
    const total = temp.reduce((acc, num, idx) => {
      return (
        acc + (idx === subindex ? Number(value) : Number(num?.credit || 0))
      );
    }, 0);

    setCreditTotal((prevCreditTotal) => {
      const updatedCreditTotal = [...prevCreditTotal];
      updatedCreditTotal[i] = total;
      return updatedCreditTotal;
    });
  };

  useEffect(() => {
    if (headings) {
      const initialDebitTotal = headings.map((item, i) => {
        return item.subHeadings.reduce((acc, subitem, subindex) => {
          const debit =
            formik.values.reportTxns[index]?.reportSubTxnDtos[i]?.subTxnDtos[
              subindex
            ]?.debit || 0;
          return acc + Number(debit);
        }, 0);
      });

      const initialCreditTotal = headings.map((item, i) => {
        return item.subHeadings.reduce((acc, subitem, subindex) => {
          const credit =
            formik.values.reportTxns[index]?.reportSubTxnDtos[i]?.subTxnDtos[
              subindex
            ]?.credit || 0;
          return acc + Number(credit);
        }, 0);
      });

      setDebitTotal(initialDebitTotal);
      setCreditTotal(initialCreditTotal);
    }
  }, [headings, formik.values.reportTxns, index]);

  const handleWheel = (e) => {
    if (e.target.type === "number") {
      e.preventDefault();
    }
  };

  return (
    <>
      {/* {mainHeading.isVisibleInCOOPOMIS && ( */}
      {/* <> */}
      <div className="table-responsive table-card w-full">
        <Table className="table align-middle table-nowrap">
          <thead className="table-light">
            <tr style={{ backgroundColor: "#e5edf6" }}>
              <td>
                {isVisible
                  ? mainHeading?.mainHeadingEngName
                  : mainHeading?.mainHeadingNepName}
              </td>
            </tr>
          </thead>
        </Table>
      </div>
      <>
        {headings?.map((item, i) => {
          return (
            <div key={i} className="table-responsive table-card mt-1 w-full">
              <Table className="table align-middle table-nowrap">
                <thead className="table-light">
                  <tr className="text-muted">
                    <td>S.N</td>
                    <td>DESCRIPTION</td>
                    <td className="text-center">CREDIT</td>
                    <td className="text-center">DEBIT</td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td
                      className="table-light fw-bold"
                      colSpan="12"
                      style={{ marginBottom: "10px" }}
                    >
                      {item?.headingEngName ?? ""}
                    </td>
                  </tr>
                  {item?.subHeadings?.map((subitem, subindex) => {
                    return (
                      <tr key={subindex}>
                        <td>
                          <span
                            className="form-control border-0"
                            style={{ backgroundColor: "#f8f9fa" }}
                          >
                            {subindex + 1}
                          </span>
                        </td>
                        <td className="col-sm-5">
                          <span
                            className="form-control border-0 fw-bold"
                            style={{ backgroundColor: "#f8f9fa" }}
                          >
                            {isVisible
                              ? subitem.subheadingEngName
                              : subitem.subheadingNepName}
                          </span>
                        </td>

                        <td>
                          <CustomInput
                            required
                            onWheel={handleWheel}
                            className="text-end"
                            // type={"number"}
                            showlabel={false}
                            autoComplete={false}
                            readOnly={read}
                            disabled={disableDraft}
                            handleBlur={formik.handleBlur}
                            handleChange={(e) => {
                              const value = parseInt(e.target.value, 10) || 0;
                              formik.setFieldValue(
                                `reportTxns.${index}.reportSubTxnDtos.${i}.subTxnDtos.${subindex}.subHeadingId`,
                                subitem.id
                              );
                              formik.setFieldValue(
                                `reportTxns.${index}.reportSubTxnDtos.${i}.subTxnDtos.${subindex}.credit`,
                                value
                              );
                              handleTotalCreditChange({
                                i: i,
                                index: index,
                                subindex: subindex,
                                value: value,
                              });
                            }}
                            id={`reportTxns.${index}.reportSubTxnDtos.${i}.subTxnDtos.${subindex}.credit`}
                            name={`reportTxns.${index}.reportSubTxnDtos.${i}.subTxnDtos.${subindex}.credit`}
                            placeholder={"Credit"}
                            touched={formik.touched.credit}
                            value={
                              formik.values.reportTxns[index]?.reportSubTxnDtos[
                                i
                              ]?.subTxnDtos[subindex]?.credit || ""
                            }
                            error={formik.errors.credit}
                          />
                        </td>

                        <td>
                          <CustomInput
                            required
                            showlabel={false}
                            className="text-end"
                            // type={"number"}
                            handleBlur={formik.handleBlur}
                            autoComplete={false}
                            readOnly={
                              report?.reportStatus === "Submitted" ||
                              report?.reportStatus === "Approved" ||
                              report?.reportStatus === "Acknowledged"
                                ? true
                                : false
                            }
                            disabled={disableDraft}
                            handleChange={(e) => {
                              const value = parseInt(e.target.value, 10) || 0;
                              formik.setFieldValue(
                                `reportTxns.${index}.reportSubTxnDtos.${i}.subTxnDtos.${subindex}.subHeadingId`,
                                subitem.id
                              );
                              formik.setFieldValue(
                                `reportTxns.${index}.reportSubTxnDtos.${i}.subTxnDtos.${subindex}.debit`,
                                value
                              );
                              handleTotalDebitChange({
                                i: i,
                                index: index,
                                subindex: subindex,
                                value: value,
                              });
                            }}
                            id={`reportTxns.${index}.reportSubTxnDtos.${i}.subTxnDtos.${subindex}.debit`}
                            name={`reportTxns.${index}.reportSubTxnDtos.${i}.subTxnDtos.${subindex}.debit`}
                            placeholder={"Debit"}
                            touched={formik.touched.debit}
                            value={
                              formik.values.reportTxns[index]?.reportSubTxnDtos[
                                i
                              ]?.subTxnDtos[subindex]?.debit || ""
                            }
                            error={formik.errors.debit}
                          />
                        </td>
                      </tr>
                    );
                  })}
                  <tr>
                    <td>
                      <span></span>
                    </td>
                    <td className="col-sm-5">
                      <span
                        className="form-control border-0 fw-bold"
                        style={{ backgroundColor: "#f8f9fa" }}
                      >
                        Total (Rs.)
                      </span>
                    </td>
                    <td>
                      <Input
                        type="text"
                        className="form-control text-end"
                        readOnly
                        value={creditTotal[i] || 0}
                        disabled={disableDraft}
                      />
                    </td>
                    <td>
                      <Input
                        type="number"
                        className="form-control text-end"
                        readOnly
                        disabled={disableDraft}
                        value={debitTotal[i] || 0}
                      />
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
          );
        })}
      </>
      {/* </> */}
      {/* )} */}
    </>
  );
};

export default TableComponent;

// import React, { useEffect, useState } from "react";
// import { Input, Table } from "reactstrap";
// import CustomInput from "../../../../Components/Common/CustomInput/CustomInput";

// function addZeroPrefix(number) {
//   let numString = number.toString();

//   if (numString.length === 1) {
//     numString = "0" + numString;
//   }

//   return Number(numString);
// }

// const TableComponent = ({
//   heading,
//   subHeadingGroups,
//   index,
//   read,
//   formik,
//   report,
//   disableDraft,
// }) => {
//   const [debitTotal, setDebitTotal] = useState([]);
//   const [creditTotal, setCreditTotal] = useState([]);
//   // console.log("formik.values", formik.values);

//   const handleTotalDebitChange = ({ index, i, subindex, value }) => {
//     const reportTxn = formik.values.reportTxns[index];
//     if (!reportTxn) return;

//     const reportSubTxnDto = reportTxn.reportSubTxnDtos[i];
//     if (!reportSubTxnDto) return;

//     const subTxnDtos = reportSubTxnDto.subTxnDtos;
//     if (!subTxnDtos) return;

//     const total = subTxnDtos.reduce((acc, num, idx) => {
//       return (
//         acc +
//         (idx === subindex
//           ? Number(value)
//           : Number(num?.debit || 0))
//       );
//     }, 0);

//     setDebitTotal((prevDebitTotal) => {
//       const updatedDebitTotal = [...prevDebitTotal];
//       updatedDebitTotal[i] = total;
//       return updatedDebitTotal;
//     });
//   };

//   const handleTotalCreditChange = ({ index, i, subindex, value }) => {
//     const reportTxn = formik.values.reportTxns[index];
//     if (!reportTxn) return;

//     const reportSubTxnDto = reportTxn.reportSubTxnDtos[i];
//     if (!reportSubTxnDto) return;

//     const subTxnDtos = reportSubTxnDto.subTxnDtos;
//     if (!subTxnDtos) return;

//     const total = subTxnDtos.reduce((acc, num, idx) => {
//       return (
//         acc +
//         (idx === subindex
//           ? Number(value)
//           : Number(num?.credit || 0))
//       );
//     }, 0);

//     setCreditTotal((prevCreditTotal) => {
//       const updatedCreditTotal = [...prevCreditTotal];
//       updatedCreditTotal[i] = total;
//       return updatedCreditTotal;
//     });
//   };

//   return (
//     <>
//       {" "}
//       <div className="table-responsive table-card  w-full">
//         <Table className="table align-middle table-nowrap">
//           <thead className="table-light ">
//             <tr style={{ backgroundColor: "#e5edf6" }}>
//               <td>{heading}</td>
//             </tr>
//           </thead>
//         </Table>
//       </div>
//       {subHeadingGroups?.map((item, i) => {
//         return (
//           <div className="table-responsive table-card mt-1  w-full">
//             <Table className="table align-middle table-nowrap">
//               <thead className="table-light">
//                 <tr className="text-muted">
//                   <td>S.N</td>
//                   <td>DESCRIPTION</td>
//                   <td className="text-center">CREDIT</td>{" "}
//                   <td className="text-center">DEBIT</td>
//                 </tr>
//               </thead>
//               <tbody>
//                 <tr>
//                   <td
//                     className="table-light fw-bold"
//                     colSpan="12"
//                     style={{ marginBottom: "10px" }}
//                   >
//                     {item.groupType ?? ""}
//                   </td>
//                 </tr>
//                 {item.subHeadings.map((subitem, subindex) => {
//                   return (
//                     <tr>
//                       <td>
//                         <span
//                           className=" form-control border-0"
//                           style={{ backgroundColor: "#f8f9fa" }}
//                         >
//                           {subindex + 1}
//                         </span>
//                       </td>
//                       <td className="col-sm-5">
//                         <span
//                           className=" form-control border-0 fw-bold"
//                           style={{ backgroundColor: "#f8f9fa" }}
//                         >
//                           {subitem.subheadingEngName}
//                         </span>
//                       </td>

//                       <td>
//                         <CustomInput
//                           required
//                           // label={"Debit"}
//                           className="text-end"
//                           type={"number"}
//                           showlabel={false}
//                           autoComplete={false}
//                           readOnly={read}
//                           disabled={disableDraft}
//                           handleBlur={formik.handleBlur}
//                           handleChange={(e) => {
//                             formik.setFieldValue(
//                               `reportTxns.${index}.reportSubTxnDtos.${i}.subTxnDtos.${subindex}.subHeadingId`,
//                               subitem.id
//                             );
//                             formik.setFieldValue(
//                               `reportTxns.${index}.reportSubTxnDtos.${i}.subTxnDtos.${subindex}.credit`,
//                               e.target.value
//                             );
//                             handleTotalCreditChange({
//                               i: i,
//                               index: index,
//                               subindex: subindex,
//                               value: e.target.value,
//                             });
//                           }}
//                           id={`reportTxns.${index}.reportSubTxnDtos.${i}.subTxnDtos.${subindex}.credit`}
//                           name={`reportTxns.${index}.reportSubTxnDtos.${i}.subTxnDtos.${subindex}.credit`}
//                           placeholder={"Credit"}
//                           touched={formik.touched.credit}
//                           value={
//                             formik.values.reportTxns[index]?.reportSubTxnDtos[i]
//                               ?.subTxnDtos[subindex]?.credit
//                           }
//                           error={formik.errors.credit}
//                         />
//                       </td>

//                       <td>
//                         <CustomInput
//                           required
//                           showlabel={false}
//                           className="text-end"
//                           type={"number"}
//                           handleBlur={formik.handleBlur}
//                           autoComplete={false}
//                           readOnly={
//                             report?.reportStatus === "Submitted" ||
//                             report?.reportStatus === "Approved" ||
//                             report?.reportStatus === "Acknowledged"
//                               ? true
//                               : false
//                           }
//                           disabled={disableDraft}
//                           handleChange={(e) => {
//                             formik.setFieldValue(
//                               `reportTxns.${index}.reportSubTxnDtos.${i}.subTxnDtos.${subindex}.subHeadingId`,
//                               subitem.id
//                             );

//                             formik.setFieldValue(
//                               `reportTxns.${index}.reportSubTxnDtos.${i}.subTxnDtos.${subindex}.debit`,
//                               e.target.value
//                             );

//                             handleTotalDebitChange({
//                               i: i,
//                               index: index,
//                               subindex: subindex,
//                               value: e.target.value,
//                             });
//                           }}
//                           id={`reportTxns.${index}.reportSubTxnDtos.${i}.subTxnDtos.${subindex}.debit`}
//                           name={`reportTxns.${index}.reportSubTxnDtos.${i}.subTxnDtos.${subindex}.debit`}
//                           placeholder={"Debit"}
//                           touched={formik.touched.debit}
//                           value={
//                             formik.values.reportTxns[index]?.reportSubTxnDtos[i]
//                               ?.subTxnDtos[subindex]?.debit
//                           }
//                           error={formik.errors.debit}
//                         />
//                       </td>
//                     </tr>
//                   );
//                 })}
//                 <tr>
//                   <td>
//                     <span></span>
//                   </td>
//                   <td className="col-sm-5">
//                     <span
//                       className=" form-control border-0 fw-bold"
//                       style={{ backgroundColor: "#f8f9fa" }}
//                     >
//                       Total (Rs.)
//                     </span>
//                   </td>
//                   <td>
//                     <Input
//                       type="text"
//                       className=" form-control text-end"
//                       readOnly
//                       value={creditTotal[i]}
//                       disabled={disableDraft}

//                       // placeholder={
//                       //   reportStatus === "new report" ? "" : `Rs. 28,368,801.83`
//                       // }
//                       // readOnly={
//                       //   reportStatus === "submitted" ||
//                       //   reportStatus === "approved"
//                       // }
//                     />
//                   </td>
//                   <td>
//                     <Input
//                       type="number"
//                       className=" form-control text-end"
//                       readOnly
//                       disabled={disableDraft}
//                       value={debitTotal[i]}
//                       // readOnly={
//                       //   reportStatus === "submitted" ||
//                       //   reportStatus === "approved"
//                       // }
//                     />
//                   </td>
//                 </tr>
//               </tbody>
//             </Table>
//           </div>
//         );
//       })}
//     </>
//   );
// };

// export default TableComponent;
